<dx-pie-chart [ngClass]="{ compact: displayCompact }"
              [dataSource]="chartData"
              type="doughnut"
              resolveLabelOverlapping="shift"
              [customizePoint]="customiseChartPoint"
              [startAngle]="90"
              (onDone)="updateChartDimensionAndSubscribeSizeChange($event)">
    <dxo-pie-chart-animation [enabled]="false"></dxo-pie-chart-animation>
    <dxo-pie-chart-legend orientation="horizontal"
                          itemTextPosition="right"
                          horizontalAlignment="center"
                          verticalAlignment="bottom"
                          [columnCount]="4"></dxo-pie-chart-legend>
    <dxi-pie-chart-series argumentField="label"
                          [minSegmentSize]="0"
                          valueField="count">
        <dxo-pie-chart-label [visible]="true"
                             position="columns"
                             [customizeText]="customiseLabel">
            <dxo-pie-chart-font [size]="11"></dxo-pie-chart-font>
            <dxo-pie-chart-connector [visible]="true"
                                     [width]="0.5"></dxo-pie-chart-connector>
        </dxo-pie-chart-label>
    </dxi-pie-chart-series>
    <dxo-pie-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customiseChartTooltip"></dxo-pie-chart-tooltip>
</dx-pie-chart>
